/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Body_upload_declaration_file_latest_fsp_declarations_declaration__declaration_id__file_put } from '../models/Body_upload_declaration_file_latest_fsp_declarations_declaration__declaration_id__file_put';
import type { Body_upload_declaration_file_v1_fsp_declarations_declaration__declaration_id__file_put } from '../models/Body_upload_declaration_file_v1_fsp_declarations_declaration__declaration_id__file_put';
import type { DeclarationEditSchema } from '../models/DeclarationEditSchema';
import type { DeclarationInSchema } from '../models/DeclarationInSchema';
import type { DeclarationListOutSchema } from '../models/DeclarationListOutSchema';
import type { DeclarationOutSchema } from '../models/DeclarationOutSchema';
import type { EnumDeclarationReviewStatus } from '../models/EnumDeclarationReviewStatus';
import type { FileUploadBase64 } from '../models/FileUploadBase64';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class DeclarationsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get Declarations
     * ### Get Declarations
     *
     * Retrieve all declarations.
     *
     * **Permissions Required**:
     * `permission:can_manage_declarations`
     *
     * **Parameters**:
     * - Optional **declaration_status**: `EnumDeclarationReviewStatus` object to filter declarations by status, default: None.
     * - Optional **limit**: `int` object to limit the number of declarations returned, default: 100.
     * - Optional **offset**: `int` object to offset the number of declarations returned, default: 0.
     *
     * **Returns**:
     * - ListSchema: List of declarations with metadata.
     *
     * ** Future Improvements **:
     * - Add ordering to parameters
     * @param declarationStatus
     * @param limit
     * @param offset
     * @returns DeclarationListOutSchema Successful Response
     * @throws ApiError
     */
    public getFspGetDeclarations(
        declarationStatus?: (EnumDeclarationReviewStatus | null),
        limit?: (number | null),
        offset?: (number | null),
    ): CancelablePromise<DeclarationListOutSchema> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/fsp/declarations/declarations',
            query: {
                'declaration_status': declarationStatus,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Coach Declarations
     * ### Get Coach Declarations
     *
     * Retrieve all declarations associated with a specific coach.
     *
     * **Permissions Required**:
     * `view_coach_declarations`
     * ***found in:***
     * - `permission:can_manage_declarations`
     * - `User` == matching `Coach`
     *
     * **Parameters**:
     * - **coach**: `Coach` object, fetched by the path parameter.
     * - Optional **declaration_status**: `EnumDeclarationReviewStatus` object to filter declarations by status.
     * - Optional **limit**: `int` object to limit the number of declarations returned.
     * - Optional **offset**: `int` object to offset the number of declarations returned.
     *
     * **Returns**:
     * - `List[DeclarationOutSchema]`: List of declarations for the specified coach.
     * @param coachId
     * @param declarationStatus
     * @param limit
     * @param offset
     * @returns DeclarationListOutSchema Successful Response
     * @throws ApiError
     */
    public getFspGetCoachDeclarations(
        coachId: number,
        declarationStatus?: (EnumDeclarationReviewStatus | null),
        limit?: (number | null),
        offset?: (number | null),
    ): CancelablePromise<DeclarationListOutSchema> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/fsp/declarations/{coach_id}/declarations',
            path: {
                'coach_id': coachId,
            },
            query: {
                'declaration_status': declarationStatus,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Coach Declaration
     * ### Create Coach Declaration
     *
     * Create a new declaration for a specific coach.
     *
     * **Permissions Required**:
     * `create_declaration`
     * ***found in:***
     * - `permission:can_manage_declarations`
     * - `User` == matching `Coach`
     *
     * **Parameters**:
     * - **declaration_in**: `DeclarationInSchema` object containing the declaration details.
     * - **coach**: `Coach` object, fetched by the path parameter.
     *
     * **Returns**:
     * - `DeclarationOutSchema`: The created declaration object.
     * @param coachId
     * @param requestBody
     * @returns DeclarationOutSchema Successful Response
     * @throws ApiError
     */
    public postFspCreateCoachDeclaration(
        coachId: number,
        requestBody: DeclarationInSchema,
    ): CancelablePromise<DeclarationOutSchema> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/fsp/declarations/{coach_id}/declaration',
            path: {
                'coach_id': coachId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Upload Declaration File
     * ### Upload Declaration File
     *
     * Upload a file for a specific declaration.
     *
     * **Permissions Required**:
     * `DeclarationPermission.EDIT`
     * ***found in:***
     * - `permission:can_manage_declarations`
     * - `User` == matching `Coach`
     *
     * **Parameters**:
     * - **declaration**: `Declaration` object, fetched by path parameter.
     * - **file**: `UploadFile` object containing the file to upload.
     *
     * **Returns**:
     * - `DeclarationOutSchema`: The updated declaration object.
     *
     * **Exceptions**:
     * - Raises a 400 error if the file size is too large. (default max size is 10MB)
     * - Raises a 400 error if the file type is not allowed. (only PDF, Word, and images are allowed)
     * - Raises a 400 error if the file upload fails.
     * @param declarationId
     * @param formData
     * @returns DeclarationOutSchema Successful Response
     * @throws ApiError
     */
    public putFspUploadDeclarationFile(
        declarationId: number,
        formData: Body_upload_declaration_file_v1_fsp_declarations_declaration__declaration_id__file_put,
    ): CancelablePromise<DeclarationOutSchema> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v1/fsp/declarations/declaration/{declaration_id}/file',
            path: {
                'declaration_id': declarationId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Upload Declaration File Base64
     * ### Upload Declaration File
     *
     * Upload a file for a specific declaration.
     *
     * **Permissions Required**:
     * `DeclarationPermission.EDIT`
     * ***found in:***
     * - `permission:can_manage_declarations`
     * __OR__
     * - `User` == matching `Coach`
     *
     * **Parameters**:
     * - **declaration**: `Declaration` object, fetched by path parameter.
     * - BODY element is the file encoded in base64.
     *
     * **Returns**:
     * - `DeclarationOutSchema`: The updated declaration object.
     *
     * **Exceptions**:
     * - Raises a 400 error if the file size is too large. (default max size is 10MB)
     * - Raises a 400 error if the file type is not allowed. (only PDF, Word, images are allowed)
     * - Raises a 400 error if the file upload fails.
     *
     * `!!!` The mime type extractions is still experimental, so if any expected allowed mime_type is rejected, report the issue`!!!`
     *
     * `!!!` __This endpoint is not in working condition via SwaggerUI, but works via the generated react-native api in the apps.__ `!!!`
     * @param declarationId
     * @param requestBody
     * @returns DeclarationOutSchema Successful Response
     * @throws ApiError
     */
    public putFspUploadDeclarationFileBase64(
        declarationId: number,
        requestBody: FileUploadBase64,
    ): CancelablePromise<DeclarationOutSchema> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v1/fsp/declarations/declaration/{declaration_id}/file_base64',
            path: {
                'declaration_id': declarationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Declaration
     * ### Delete Declaration
     *
     * Delete a specific declaration.
     *
     * **Permissions Required**:
     * `DeclarationPermission.DELETE`
     * ***found in:***
     * - `permission:can_manage_declarations`
     * - `User` == matching `Coach`
     *
     * **Parameters**:
     * - **declaration**: `Declaration` object, fetched by path parameter.
     *
     * **Returns**:
     * - `dict`: Message confirming deletion of the declaration.
     * @param declarationId
     * @returns any Successful Response
     * @throws ApiError
     */
    public deleteFspDeleteDeclaration(
        declarationId: number,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/v1/fsp/declarations/declaration/{declaration_id}',
            path: {
                'declaration_id': declarationId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Review Declaration
     * ### Review Declaration
     *
     * Update the review status of a specific declaration.
     *
     * **Permissions Required**:
     * `DeclarationPermission.REVIEW`
     * ***found in:***
     * - `permission:can_manage_declarations`
     *
     * **Parameters**:
     * - **updated_at**: `datetime` object to check if the declaration has been updated by another user.
     * - **review_status**: `EnumDeclarationReviewStatus` object for the new review status.
     * - **declaration**: `Declaration` object, fetched by path parameter.
     *
     * **Returns**:
     * - `DeclarationOutSchema`: The updated declaration with the new review status.
     * @param reviewStatus
     * @param declarationId
     * @param updatedAt
     * @returns DeclarationOutSchema Successful Response
     * @throws ApiError
     */
    public patchFspReviewDeclaration(
        reviewStatus: EnumDeclarationReviewStatus,
        declarationId: number,
        updatedAt: string,
    ): CancelablePromise<DeclarationOutSchema> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/v1/fsp/declarations/declaration/{declaration_id}/review/{review_status}',
            path: {
                'review_status': reviewStatus,
                'declaration_id': declarationId,
            },
            query: {
                'updated_at': updatedAt,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Edit Declaration
     * ### Edit Declaration
     *
     * Edit an existing declaration.
     *
     * **Permissions Required**:
     * - permission:can_manage_declarations
     * -- OR --
     * - user == matching coach
     *
     * **Parameters**:
     * - **declaration_edit**: `DeclarationEditSchema` object containing updated declaration details.
     * - **declaration**: `Declaration` object, fetched by path parameter.
     *
     * **Returns**:
     * - `DeclarationOutSchema`: The edited declaration object.
     * @param declarationId
     * @param requestBody
     * @returns DeclarationOutSchema Successful Response
     * @throws ApiError
     */
    public patchFspEditDeclaration(
        declarationId: number,
        requestBody: DeclarationEditSchema,
    ): CancelablePromise<DeclarationOutSchema> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/v1/fsp/declarations/declaration/{declaration_id}/edit',
            path: {
                'declaration_id': declarationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Declarations
     * ### Get Declarations
     *
     * Retrieve all declarations.
     *
     * **Permissions Required**:
     * `permission:can_manage_declarations`
     *
     * **Parameters**:
     * - Optional **declaration_status**: `EnumDeclarationReviewStatus` object to filter declarations by status, default: None.
     * - Optional **limit**: `int` object to limit the number of declarations returned, default: 100.
     * - Optional **offset**: `int` object to offset the number of declarations returned, default: 0.
     *
     * **Returns**:
     * - ListSchema: List of declarations with metadata.
     *
     * ** Future Improvements **:
     * - Add ordering to parameters
     * @param declarationStatus
     * @param limit
     * @param offset
     * @returns DeclarationListOutSchema Successful Response
     * @throws ApiError
     */
    public getFspGetDeclarationsVLatest(
        declarationStatus?: (EnumDeclarationReviewStatus | null),
        limit?: (number | null),
        offset?: (number | null),
    ): CancelablePromise<DeclarationListOutSchema> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/latest/fsp/declarations/declarations',
            query: {
                'declaration_status': declarationStatus,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Coach Declarations
     * ### Get Coach Declarations
     *
     * Retrieve all declarations associated with a specific coach.
     *
     * **Permissions Required**:
     * `view_coach_declarations`
     * ***found in:***
     * - `permission:can_manage_declarations`
     * - `User` == matching `Coach`
     *
     * **Parameters**:
     * - **coach**: `Coach` object, fetched by the path parameter.
     * - Optional **declaration_status**: `EnumDeclarationReviewStatus` object to filter declarations by status.
     * - Optional **limit**: `int` object to limit the number of declarations returned.
     * - Optional **offset**: `int` object to offset the number of declarations returned.
     *
     * **Returns**:
     * - `List[DeclarationOutSchema]`: List of declarations for the specified coach.
     * @param coachId
     * @param declarationStatus
     * @param limit
     * @param offset
     * @returns DeclarationListOutSchema Successful Response
     * @throws ApiError
     */
    public getFspGetCoachDeclarationsVLatest(
        coachId: number,
        declarationStatus?: (EnumDeclarationReviewStatus | null),
        limit?: (number | null),
        offset?: (number | null),
    ): CancelablePromise<DeclarationListOutSchema> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/latest/fsp/declarations/{coach_id}/declarations',
            path: {
                'coach_id': coachId,
            },
            query: {
                'declaration_status': declarationStatus,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Coach Declaration
     * ### Create Coach Declaration
     *
     * Create a new declaration for a specific coach.
     *
     * **Permissions Required**:
     * `create_declaration`
     * ***found in:***
     * - `permission:can_manage_declarations`
     * - `User` == matching `Coach`
     *
     * **Parameters**:
     * - **declaration_in**: `DeclarationInSchema` object containing the declaration details.
     * - **coach**: `Coach` object, fetched by the path parameter.
     *
     * **Returns**:
     * - `DeclarationOutSchema`: The created declaration object.
     * @param coachId
     * @param requestBody
     * @returns DeclarationOutSchema Successful Response
     * @throws ApiError
     */
    public postFspCreateCoachDeclarationVLatest(
        coachId: number,
        requestBody: DeclarationInSchema,
    ): CancelablePromise<DeclarationOutSchema> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/latest/fsp/declarations/{coach_id}/declaration',
            path: {
                'coach_id': coachId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Upload Declaration File
     * ### Upload Declaration File
     *
     * Upload a file for a specific declaration.
     *
     * **Permissions Required**:
     * `DeclarationPermission.EDIT`
     * ***found in:***
     * - `permission:can_manage_declarations`
     * - `User` == matching `Coach`
     *
     * **Parameters**:
     * - **declaration**: `Declaration` object, fetched by path parameter.
     * - **file**: `UploadFile` object containing the file to upload.
     *
     * **Returns**:
     * - `DeclarationOutSchema`: The updated declaration object.
     *
     * **Exceptions**:
     * - Raises a 400 error if the file size is too large. (default max size is 10MB)
     * - Raises a 400 error if the file type is not allowed. (only PDF, Word, and images are allowed)
     * - Raises a 400 error if the file upload fails.
     * @param declarationId
     * @param formData
     * @returns DeclarationOutSchema Successful Response
     * @throws ApiError
     */
    public putFspUploadDeclarationFileVLatest(
        declarationId: number,
        formData: Body_upload_declaration_file_latest_fsp_declarations_declaration__declaration_id__file_put,
    ): CancelablePromise<DeclarationOutSchema> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/latest/fsp/declarations/declaration/{declaration_id}/file',
            path: {
                'declaration_id': declarationId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Upload Declaration File Base64
     * ### Upload Declaration File
     *
     * Upload a file for a specific declaration.
     *
     * **Permissions Required**:
     * `DeclarationPermission.EDIT`
     * ***found in:***
     * - `permission:can_manage_declarations`
     * __OR__
     * - `User` == matching `Coach`
     *
     * **Parameters**:
     * - **declaration**: `Declaration` object, fetched by path parameter.
     * - BODY element is the file encoded in base64.
     *
     * **Returns**:
     * - `DeclarationOutSchema`: The updated declaration object.
     *
     * **Exceptions**:
     * - Raises a 400 error if the file size is too large. (default max size is 10MB)
     * - Raises a 400 error if the file type is not allowed. (only PDF, Word, images are allowed)
     * - Raises a 400 error if the file upload fails.
     *
     * `!!!` The mime type extractions is still experimental, so if any expected allowed mime_type is rejected, report the issue`!!!`
     *
     * `!!!` __This endpoint is not in working condition via SwaggerUI, but works via the generated react-native api in the apps.__ `!!!`
     * @param declarationId
     * @param requestBody
     * @returns DeclarationOutSchema Successful Response
     * @throws ApiError
     */
    public putFspUploadDeclarationFileBase64VLatest(
        declarationId: number,
        requestBody: FileUploadBase64,
    ): CancelablePromise<DeclarationOutSchema> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/latest/fsp/declarations/declaration/{declaration_id}/file_base64',
            path: {
                'declaration_id': declarationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Declaration
     * ### Delete Declaration
     *
     * Delete a specific declaration.
     *
     * **Permissions Required**:
     * `DeclarationPermission.DELETE`
     * ***found in:***
     * - `permission:can_manage_declarations`
     * - `User` == matching `Coach`
     *
     * **Parameters**:
     * - **declaration**: `Declaration` object, fetched by path parameter.
     *
     * **Returns**:
     * - `dict`: Message confirming deletion of the declaration.
     * @param declarationId
     * @returns any Successful Response
     * @throws ApiError
     */
    public deleteFspDeleteDeclarationVLatest(
        declarationId: number,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/latest/fsp/declarations/declaration/{declaration_id}',
            path: {
                'declaration_id': declarationId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Review Declaration
     * ### Review Declaration
     *
     * Update the review status of a specific declaration.
     *
     * **Permissions Required**:
     * `DeclarationPermission.REVIEW`
     * ***found in:***
     * - `permission:can_manage_declarations`
     *
     * **Parameters**:
     * - **updated_at**: `datetime` object to check if the declaration has been updated by another user.
     * - **review_status**: `EnumDeclarationReviewStatus` object for the new review status.
     * - **declaration**: `Declaration` object, fetched by path parameter.
     *
     * **Returns**:
     * - `DeclarationOutSchema`: The updated declaration with the new review status.
     * @param reviewStatus
     * @param declarationId
     * @param updatedAt
     * @returns DeclarationOutSchema Successful Response
     * @throws ApiError
     */
    public patchFspReviewDeclarationVLatest(
        reviewStatus: EnumDeclarationReviewStatus,
        declarationId: number,
        updatedAt: string,
    ): CancelablePromise<DeclarationOutSchema> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/latest/fsp/declarations/declaration/{declaration_id}/review/{review_status}',
            path: {
                'review_status': reviewStatus,
                'declaration_id': declarationId,
            },
            query: {
                'updated_at': updatedAt,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Edit Declaration
     * ### Edit Declaration
     *
     * Edit an existing declaration.
     *
     * **Permissions Required**:
     * - permission:can_manage_declarations
     * -- OR --
     * - user == matching coach
     *
     * **Parameters**:
     * - **declaration_edit**: `DeclarationEditSchema` object containing updated declaration details.
     * - **declaration**: `Declaration` object, fetched by path parameter.
     *
     * **Returns**:
     * - `DeclarationOutSchema`: The edited declaration object.
     * @param declarationId
     * @param requestBody
     * @returns DeclarationOutSchema Successful Response
     * @throws ApiError
     */
    public patchFspEditDeclarationVLatest(
        declarationId: number,
        requestBody: DeclarationEditSchema,
    ): CancelablePromise<DeclarationOutSchema> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/latest/fsp/declarations/declaration/{declaration_id}/edit',
            path: {
                'declaration_id': declarationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
